import { EntityMetadata } from '@ngrx/data';

export interface RecallsDashboardQueryFilter {
    jobIds?: Array<number>;
}
/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const recallsDashboardEntityMetadata: EntityMetadata<any> = {
    entityName: 'RecallsDashboard',
    selectId: jobSelectId, // .id is used if doing optimistic update
    additionalCollectionState: {
        refreshing: false,
        queryFilter: {
            jobIds: []
        },
        totalRecallsCount: 0
    }
};

// tslint:disable-next-line:only-arrow-functions typedef
export function jobSelectId<T extends { id: any }>(recalls: any) {
    return  recalls === undefined ? undefined : recalls.id || recalls.jobId;  // .id is used if doing optimistic update
}

